import EmptyState from "ds/components/EmptyState";
import { EmptystateShareColored } from "components/icons/generated";
import Box from "ds/components/Box";

const IdpGroupUsersEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="IdP group doesn’t have any users assigned yet"
        icon={EmptystateShareColored}
      />
    </Box>
  );
};

export default IdpGroupUsersEmpty;
